import { StickyInfo } from "./sticky-info";

export class Message {
    public __classname__: string = 'Message';

    public ObjectID : string | null = null;
	public UserID : string | null = null;
	public MessageID : string | null = null;
	public MessageType : string | null = null;
	public MessageTypeDetail : string | null = null;
	public Message : string | null = null;
	public TimeStamp : string | null = null;
	public Expiration : string | null = null;
	public MessageLevel : string | null = null;
	public FromUser : string | null = null;
	public StickyInfo : StickyInfo | null = null;
	public ThreadMessageID : string | null = null;
	public ReplyToMessageID : string | null = null;
	public MessageStatus : string | null = null;
	public ObjectVersion : string | null = null;

    constructor(
        ObjectID : string | null = null, 
        UserID : string | null = null, 
        MessageID : string | null = null, 
        MessageType : string | null = null, 
        MessageTypeDetail : string | null = null, 
        Message : string | null = null, 
        TimeStamp : string | null = null, 
        Expiration : string | null = null, 
        MessageLevel : string | null = null, 
        FromUser : string | null = null, 
        StickyInfo : StickyInfo | null = null, 
        ThreadMessageID : string | null = null, 
        ReplyToMessageID : string | null = null, 
        MessageStatus : string | null = null, 
        ObjectVersion : string | null = null
    ) {
        this.ObjectID = ObjectID;
        this.UserID = UserID;
        this.MessageID = MessageID;
        this.MessageType = MessageType;
        this.MessageTypeDetail = MessageTypeDetail;
        this.Message = Message;
        this.TimeStamp = TimeStamp;
        this.Expiration = Expiration;
        this.MessageLevel = MessageLevel;
        this.FromUser = FromUser;
        this.StickyInfo = StickyInfo;
        this.ThreadMessageID = ThreadMessageID;
        this.ReplyToMessageID = ReplyToMessageID;
        this.MessageStatus = MessageStatus;
        this.ObjectVersion = ObjectVersion;
    }
}